const categories = {
  'categories-breadcrumbs': 'Категории',
  'categories-details-title': 'Категория',
  'categories-filter-title': 'Фильтр категорий',
  'categories-create-form-field-client-id-help': 'Уникальный ID для "core" клиента для распознания категории',
  'categories-create-form-field-name-placeholder': 'Введите название категории',
  'categories-create-form-field-description-placeholder': 'Введите описание',
  'categories-form-field-options': 'Доп. опции',
  'categories-form-field-options-placeholder': 'Введите доп. опции',
  'categories-form-field-options-help': 'Вы можете передавать различные мета-параметры в виде таргета (min_app_version, core_version и т. д.) в формате JSON. Примечание: опции имеют более высокий приоритет, чем таргеты.',
  'categories-create-form-field-dictionary-placeholder': 'Выберите словарь',
  'categories-view-images': 'Изображения',
  'categories-view-images-empty': 'Нет изображений',
  'categories-priorities': 'Приоритеты',
  'categories-deleted-at': 'Удалено',
  'categories-priorities-title': 'Перетащите категории чтобы установить нужный приоритет',
  'categories-priorities-empty': 'Категории отсутствуют',
  'categories-priorities-disabled-action': 'Перетащите категории для последующего обновления приоритетов',
  'categories-delete-notification': 'В случае если категория содержит изображения, они автоматически отвяжутся из категории.',
};

export default categories;
